"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @reslava-loom/telemetry — portable, content-free telemetry core.
 *
 * Public surface:
 *  - TelemetryClient / TelemetryProps / Surface   (the contract app depends on)
 *  - NoopTelemetry / noopTelemetry                (the disabled default)
 *  - resolveConsent / TelemetryConfig             (opt-in gate — step 2)
 *  - getOrCreateInstallId / newSessionId          (identity — step 2)
 *  - buildCommonProps                             (common props — step 2)
 *  - PostHogTelemetry / createTelemetry           (transport — step 3)
 */
__exportStar(require("./types"), exports);
__exportStar(require("./noop"), exports);
__exportStar(require("./consent"), exports);
__exportStar(require("./identity"), exports);
__exportStar(require("./props"), exports);
__exportStar(require("./posthog"), exports);
